import Relay from 'react-relay';

export default class ChangeStatusMutation extends Relay.Mutation {
  getMutation() {
    return Relay.QL`mutation{changeStatus}`;
  }

  getVariables() {
    return {
      conversationId: this.props.conversationId,
      updatedStatus: this.props.updatedStatus
    };
  }

  getFatQuery() {
    return Relay.QL`
      fragment on ChangeStepPayload {
        conversation {
          status
        }
      }
    `;
  }

  getConfigs() {
    return [{
      type: 'FIELDS_CHANGE',
      fieldIDs: {
        conversation: this.props.conversationRelayId
      }
    }];
  }
}



/** WEBPACK FOOTER **
 ** ./src/mutations/ChangeStatusMutation.js
 **/